import * as ACTION_TYPES from 'actions/actionTypes';
import { SIMPLIFIED_JOB_POSTING } from 'store/constants';
import initialState from '../initialState';

export const reducer = (state = initialState[SIMPLIFIED_JOB_POSTING], action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_SIMPLIFIED_JOB_POSTING_DATA: {
      const nextState = { ...action.payload };
      return nextState;
    }
    default:
      return state;
  }
};

export default reducer;
